import styled, { css } from 'styled-components'

import { ButtonRoot, ButtonText } from '@Components/Button/Button.styled'
import { ButtonWithProgress } from '@Components/Button/ButtonWithProgress'
import { Link } from '@Components/CMS/Link'
import { BrandWrapper, ProductTitle } from '@Components/Product/Tile/styledElements'
import { generalBottomSpacing } from '@Globals/Style/mixins'

export const BuyButtonWrapper = styled.div(({ theme }) => `
  width: 100%;
  ${generalBottomSpacing};
  max-width: ${theme.cmsModule.width.small};

  .buttonInner {
    text-align: center;
    padding-top: 20px;

    button {
      margin: 0 auto;
      max-width: 500px;
    }

    .priceWrap {
      margin-bottom: 10px;
    }

    .beforePrice {
      text-decoration: line-through;
      display: inline-block;
      margin-right: 5px;
    }

    .discountPrice {
      color: ${theme.colors.red};
      display: inline-block;
    }

    .buyButton {
      width: 100%;
      max-width: 500px;
      text-transform: uppercase;
    }
  }
`)

export const CrossSellWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
  justify-content: space-between;

  ${ProductTitle} {
    min-height: 34px;
  }

  ${BrandWrapper} {
    min-height: 14px;
  }
`

export const GoToCartLink = styled(Link)`
  display: block;
  width: 100%;
  margin: 0;
`

export const StyledSmallButton = css`
  width: 100%;
  margin: 0 auto;

  ${ButtonRoot} {
    min-height: 31px;
    width: 100%;
  }

  ${ButtonText} {
    font-size: 13px;
  }
`

export const StyledButtonWithProgress = styled(ButtonWithProgress)`
  ${StyledSmallButton}
`
